class LlocTreball {
    constructor(
        public key = 0,
        public id = 0,
        public nom = "",
        public latitud = 0,
        public longitud = 0,
        public estat = 0

    ) {
        this.key = key;
        this.id = id;
        this.nom = nom;
        this.latitud = latitud;
        this.longitud = longitud;
        this.estat = estat;
    }
}

export default LlocTreball;
